/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Form, withFormik } from 'formik';
import * as Yup from 'yup';
import AutoInput from '../AutoInput';
import { get } from 'lodash';
import Axios from 'axios';

const formSchema = Yup.object().shape({
  location: Yup.string().trim().required('This is a mandatory field'),
  solution: Yup.string().trim().required('This is a mandatory field'),
});

const isTestMode = false;

const SelectLocationForm = props => {
  const {
    values,
    touched,
    errors,
    handleChange,
    setFieldValue,
    locationData,
    fetchLocationData,
    onLocationSelect,
    officeData,
    fetchOfficeData,
    onOfficeSelect,
    locationText,
    solutionText,
    fields,
  } = props;

  const LocationFieldWatermark = get(
    fields,
    'LocationFieldWatermark.value',
    '',
  );
  const OfficeFieldWatermark = get(fields, 'OfficeFieldWatermark.value', '');

  const showSolution =
    locationText.length > 2 &&
    (officeData.length || solutionText || values.locationId);
  return (
    <Form>
      {/* /api/v1/autocomplete-location?term=london&lang=en-gb */}

      <AutoInput
        setFieldValue={setFieldValue}
        inputName="location"
        inputHiddenName="locationId"
        inputPlaceHolder={LocationFieldWatermark}
        handleChange={handleChange}
        value={locationText}
        errors={errors}
        touched={touched}
        suggestions={locationData}
        fetchSuggestions={fetchLocationData}
        onSelect={onLocationSelect}
        inputIcon="icon-search"
      />

      <input name="locationId" type="hidden" value={values.locationId} />

      {/* /api/v1/autocomplete-offices-for-location?locationId=d0391e02-0dc9-4ae9-a29a-fa51ba08de4a&lang=en-gb */}
      {showSolution ? (
        <AutoInput
          setFieldValue={setFieldValue}
          inputName="solution"
          inputHiddenName="solutionId"
          value={solutionText}
          inputPlaceHolder={OfficeFieldWatermark}
          handleChange={handleChange}
          errors={errors}
          touched={touched}
          suggestions={officeData}
          fetchSuggestions={fetchOfficeData}
          onSelect={onOfficeSelect}
          inputIcon="icon-search"
        />
      ) : null}
      <input name="solutionId" type="hidden" value={values.solutionId} />

      {/* <button type="submit">Submit</button> */}
    </Form>
  );
};

class SelectLocation extends React.Component {
  state = {
    locationData: [],
    officeData: [],
    officeSuggestions: [],

    locationText: '',
    solutionText: '',
  };
  cancelTokenSource = false;
  fetchLocationData = async keyword => {
    const { fields, setFieldValue, lang } = this.props;

    this.setState(() => ({
      locationData: [],
      officeData: [],
      officeSuggestions: [],
      locationText: keyword,
      solutionText: '',
    }));
    setFieldValue('solution', '');
    setFieldValue('solutionId', '');
    setFieldValue('locationId', '');
    setFieldValue('location', '');

    if (this.cancelTokenSource) {
      // Cancel request
      this.cancelTokenSource.cancel();
    }

    if (isTestMode === false) {
      if (keyword.length > 2) {
        try {
          let LocationApiURL = get(fields, 'LocationApiURL.value', '');
          let NoMatchingLocationsText = get(
            fields,
            'NoMatchingLocationsText.value',
            '',
          );
          LocationApiURL = LocationApiURL.replace('{keyword}', keyword);
          LocationApiURL = LocationApiURL.replace('{lang}', lang);

          this.cancelTokenSource = Axios.CancelToken.source();

          const res = await Axios.get(window.location.origin + LocationApiURL, {
            cancelToken: this.cancelTokenSource.token,
          });
          let suggestionsList = [{ Name: NoMatchingLocationsText, value: '' }];
          if (res.status === 200) {
            if (res.data.length > 0) {
              suggestionsList = res.data.map(item => {
                item.value = item.Name;
                return item;
              });
            }
          }

          this.setState({
            locationData: suggestionsList,
            officeSuggestions: [],
          });
        } catch (error) {
          console.log('error >> ', error);
        }
      }
    } else {
      let result = [
        {
          TemplateId: 'fe19a179-5452-43e6-8651-8496fdfc510d',
          Name: 'London Bridge, City of London, United Kingdom',
          Url: '/en-gb/united-kingdom/london/city-of-london/london-bridge',
          ItemId: '1a7d57cd-76a6-48c5-9407-b595acd64256',
          Latitude: 51.505992,
          Longitude: -0.088051,
          ItemType: 1,
        },
        {
          TemplateId: 'fe19a179-5452-43e6-8651-8496fdfc510d',
          Name: 'London, Ontario, Canada',
          Url: '/en-gb/canada/london',
          ItemId: 'bdb61823-03f3-4110-a120-443ef1fec4ef',
          Latitude: 42.985977,
          Longitude: -81.247254,
          ItemType: 1,
        },
        {
          TemplateId: 'fe19a179-5452-43e6-8651-8496fdfc510d',
          Name: 'London, United Kingdom',
          Url: '/en-gb/united-kingdom/london',
          ItemId: 'af196125-ce80-4f84-b0c3-c4706da9f21a',
          Latitude: 51.5074,
          Longitude: -0.1278,
          ItemType: 1,
        },
      ];

      let suggestionsList = result.map(item => {
        item.value = item.Name;
        return item;
      });

      this.setState(() => ({
        locationData: suggestionsList,
        officeData: [],
        officeSuggestions: [],
        locationText: keyword,
        solutionText: '',
      }));
    }

    // setFieldValue('solution', '');
    // setFieldValue('solutionId', '');
  };

  onLocationSelect = async (selectedItem, clearNextInput) => {
    const { fields, lang } = this.props;
    const { ItemId } = selectedItem;

    this.setState({
      locationData: [],
      locationText: selectedItem.Name,
    });
    if (isTestMode === false) {
      let OfficeApiURL = get(fields, 'OfficeApiURL.value', '');
      OfficeApiURL = OfficeApiURL.replace('{locationId}', ItemId);
      OfficeApiURL = OfficeApiURL.replace('{lang}', lang);
      try {
        const res = await Axios.get(window.location.origin + OfficeApiURL);
        let suggestionsList = [];
        if (res.status === 200) {
          if (res.data.length > 0) {
            suggestionsList = res.data.map(item => {
              item.value = item.Name;
              return item;
            });
          }
        }

        this.setState(
          {
            officeData: suggestionsList,
            officeSuggestions: [],
          },
          () => {
            if (clearNextInput) {
              this.fetchOfficeData('');
            }
          },
        );
      } catch (error) {
        console.log('something going wrong');
      }
    } else {
      let result = [
        {
          TemplateId: '00bb8c06-4591-4797-9e7e-74aaf00848a7',
          Name: '18 King William Street, City of London, United Kingdom',
          Url:
            '/en-gb/united-kingdom/london/city-of-london/18-king-william-street-3757',
          Featured: false,
          ItemId: '3ce1f7cf-9f13-4dec-8a2a-df5fa93e436f',
          Latitude: 51.5113,
          Longitude: -0.087448,
          ItemType: 0,
        },
        {
          TemplateId: '00bb8c06-4591-4797-9e7e-74aaf00848a7',
          Name: '3 More London Riverside, Southwark, United Kingdom',
          Url:
            '/en-gb/united-kingdom/london/southwark/3-more-london-riverside-849',
          Featured: false,
          ItemId: '469c424e-3021-4165-9bfe-10917199375b',
          Latitude: 51.5041961,
          Longitude: -0.0798457,
          ItemType: 0,
        },
        {
          TemplateId: '00bb8c06-4591-4797-9e7e-74aaf00848a7',
          Name: '60 Cannon Street, City of London, United Kingdom',
          Url:
            '/en-gb/united-kingdom/london/city-of-london/60-cannon-street-5544',
          Featured: false,
          ItemId: '2b67118f-a503-4645-938e-e8f649f68ec0',
          Latitude: 51.5119230691599,
          Longitude: -0.0923059730201885,
          ItemType: 0,
        },
        {
          TemplateId: '00bb8c06-4591-4797-9e7e-74aaf00848a7',
          Name: '68 King William Street, City of London, United Kingdom',
          Url:
            '/en-gb/united-kingdom/london/city-of-london/68-king-william-street-5540',
          Featured: false,
          ItemId: '935f9598-f3c6-4bd6-8d1c-fe2ed449e9cb',
          Latitude: 51.5111494415918,
          Longitude: -0.0864996650122976,
          ItemType: 0,
        },
        {
          TemplateId: '00bb8c06-4591-4797-9e7e-74aaf00848a7',
          Name: '68 Lombard Street, City of London, United Kingdom',
          Url:
            '/en-gb/united-kingdom/london/city-of-london/68-lombard-street-188',
          Featured: false,
          ItemId: '1591547b-db05-420f-8a83-4b824de741ea',
          Latitude: 51.512777,
          Longitude: -0.0871935,
          ItemType: 0,
        },
        {
          TemplateId: '00bb8c06-4591-4797-9e7e-74aaf00848a7',
          Name: 'Alpha House, Southwark, United Kingdom',
          Url: '/en-gb/united-kingdom/london/southwark/alpha-house-2331',
          Featured: true,
          ItemId: '44b31eb2-c5aa-4e58-a394-3a1fc37e35bd',
          Latitude: 51.5032026,
          Longitude: -0.0920029,
          ItemType: 0,
        },
        {
          TemplateId: '00bb8c06-4591-4797-9e7e-74aaf00848a7',
          Name: 'The News Building, Southwark, United Kingdom',
          Url: '/en-gb/united-kingdom/london/southwark/the-news-building-3606',
          Featured: true,
          ItemId: 'a1b4afa3-d97f-422e-8b1c-86b8d2cc7414',
          Latitude: 51.5051022291575,
          Longitude: -0.0877911481627507,
          ItemType: 0,
        },
      ];

      let tempArr = {};

      let suggestionsList = result.map(item => {
        item.value = item.Name;
        let isFeature = item.Featured ? 'isFeature' : 'isNotFeature';
        if (!tempArr[isFeature]) {
          tempArr[isFeature] = [];
        }
        tempArr[isFeature].push(item);
        return item;
      });

      this.setState(
        {
          locationData: [],
          officeData: suggestionsList,
          officeSuggestions: [],
          locationText: selectedItem.Name,
        },
        () => {
          if (clearNextInput) {
            this.fetchOfficeData('');
          }
        },
      );
    }
  };

  fetchOfficeData = keyword => {
    const { officeData } = this.state;
    const { fields, setFieldValue } = this.props;

    const ViewAllOfficesText = get(
      this.props,
      'fields.ViewAllOfficesText.value',
      '',
    );
    setFieldValue('solution', '');
    setFieldValue('solutionId', '');

    let officeSuggestions = [];
    if (keyword.length > 0) {
      if (keyword.length > 2) {
        officeSuggestions = officeData.sort().filter(v => {
          return v.Name.toLowerCase().includes(keyword.toLowerCase());
        });
      }
    } else {
      officeSuggestions = officeData;
    }

    let tempArr = {};

    officeSuggestions.map(item => {
      item.value = item.Name;
      let isFeature = item.Featured ? 'isFeature' : 'isNotFeature';
      if (!tempArr[isFeature]) {
        tempArr[isFeature] = [];
      }
      tempArr[isFeature].push(item);
      return item;
    });

    let MaxvisibleItem = 5;
    let finalArr = [];
    if (tempArr.isFeature) {
      MaxvisibleItem--;
      const FeaturedOfficesText = get(fields, 'FeaturedOfficesText.value', '');
      finalArr = [
        { value: '', isGroupTitle: true, Name: FeaturedOfficesText },
        ...tempArr.isFeature,
      ];
    }
    if (tempArr.isNotFeature) {
      const AllOfficesText = get(fields, 'AllOfficesText.value', '');
      MaxvisibleItem--;
      finalArr = [
        ...finalArr,
        { value: '', isGroupTitle: true, Name: AllOfficesText },
        ...tempArr.isNotFeature,
      ];
    }

    if (finalArr.length > MaxvisibleItem) {
      finalArr.push({
        value: '',
        Name: ViewAllOfficesText,
        isViewAll: true,
      });
    }

    if (finalArr.length === 0 && keyword.length > 2) {
      let NoMatchingLocationsText = get(
        fields,
        'NoMatchingLocationsText.value',
        '',
      );
      finalArr = [{ Name: NoMatchingLocationsText, value: '' }];
    }

    this.setState({ officeSuggestions: finalArr, solutionText: keyword });
  };

  onOfficeSelect = selectedItem => {
    this.setState({
      locationData: [],
      officeSuggestions: [],
      solutionText: selectedItem.Name,
    });
  };

  componentDidMount() {
    const {
      setValidationAction,
      submitForm,
      location,
      locationId,
      solution,
    } = this.props;

    if (locationId) {
      this.onLocationSelect({ ItemId: locationId }, false);
      this.setState({
        locationText: location,
        solutionText: solution,
      });
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      const geoId = urlParams.get('geoId');
      if (geoId) {
        this.getLocationDataById(geoId);
      }
    }

    if (setValidationAction) {
      setValidationAction(submitForm);
    }
  }

  getLocationDataById = async geoId => {
    const { fields, setFieldValue } = this.props;
    let GetGeoSolutionByIdApiUrl = get(
      fields,
      'GetGeoSolutionByIdApiUrl.value',
      '',
    );
    if (GetGeoSolutionByIdApiUrl) {
      GetGeoSolutionByIdApiUrl = GetGeoSolutionByIdApiUrl.replace(
        '{geoId}',
        geoId,
      );
      GetGeoSolutionByIdApiUrl = GetGeoSolutionByIdApiUrl.replace(
        '{lang}',
        this.props.lang,
      );

      try {
        const result = await Axios.get(GetGeoSolutionByIdApiUrl);
        if (result.status === 200) {
          const { data } = result;
          if (data) {
            setFieldValue('location', data[0].Name);
            setFieldValue('locationId', data[0].ItemId);
            this.setState({
              locationText: data[0].Name,
            });
            this.onLocationSelect({ ItemId: data[0].ItemId }, false);
          }
        }
      } catch (error) {
        console.log('something wrong while getch geo data');
      }
    }
  };

  render() {
    const { ...other } = this.props;
    const {
      locationData,
      officeSuggestions,
      locationText,
      solutionText,
    } = this.state;

    return (
      <SelectLocationForm
        locationData={locationData}
        fetchLocationData={this.fetchLocationData}
        onLocationSelect={params => this.onLocationSelect(params, true)}
        officeData={officeSuggestions}
        fetchOfficeData={this.fetchOfficeData}
        onOfficeSelect={this.onOfficeSelect}
        locationText={locationText}
        solutionText={solutionText}
        {...other}
      />
    );
  }
}

export default withFormik({
  mapPropsToValues: param => {
    return {
      location: param.location,
      locationId: param.locationId,
      solution: param.solution,
      solutionId: param.solutionId,
    };
  },
  validationSchema: formSchema,
  handleSubmit: (values, param) => {
    const { setSubmitting, props } = param;
    if (props.onSaveStepData) {
      props.onSaveStepData(values);
    }
    setSubmitting(false);
  },

  displayName: 'SelectLocationForm',
})(SelectLocation);
